<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("Batch registration")}}</h1>
        </v-flex>

        <v-flex xs12 class="mb-4">
          <v-layout row wrap>
          <div>
            <v-btn class="ml-3 mt-2 mr-3" :loading="loading" color="primary" @click="loadBatchRegistrations(false)"><v-icon>search</v-icon>{{$t('Refresh')}}</v-btn>
            <v-flex xs12>
              <div class="ml-6 textsize-small" style="text-align: left">{{$t("Updated")}} {{timeSinceLastUpdate}}</div>
            </v-flex>
          </div>
          <v-flex grow></v-flex>
          <v-flex shrink><v-select class="ml-2" hide-details="true" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
          </v-layout>
        </v-flex>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No unfinished registrations found")}}</div>
          <div v-else>
            <v-flex xs12>
              <h2 class="mb-2 mt-0">{{$t("Active agreements")}} ({{registrations ? registrations.length : 0}}):</h2>
            </v-flex>
          <template v-for="batchRegistrations in registrations">
             <div :key="batchRegistrations.id">
              <ActiveBatchRegistration :batchRegistration="batchRegistrations"/>
              </div>
          </template>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <h2 class="mb-4 mt-4">{{$t("Finished agreements")}}</h2>
        </v-flex>

        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <div v-if="recentregistrations != null && recentregistrations.length == 0" class="mt-4" style="text-align: center">{{$t("No recent registrations found")}}</div>
          <div v-else v-for="recentReg in recentregistrations" :key="recentReg.id">
              <RecentBatchRegistration :recentReg="recentReg"/>
          </div>

        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as BatchRegistrations from '@/modules/batch-registration/batch-registration'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
import ActiveBatchRegistration from '@/modules/batch-registration/views/ActiveBatchRegistration'
import RecentBatchRegistration from '@/modules/batch-registration/views/RecentBatchRegistration'
import * as Security from '@/core/security'
import _ from 'lodash' // clone

export default {
  mixins: [filters],
  name: 'batch-registration',
  components: { ActiveBatchRegistration, RecentBatchRegistration },
  data () {
    return {
      loading: false,
      registrations: null,
      recentregistrations: null,
      facilityNo: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      focusedRegistration: null,
      returnTo: 'pre-registration-registrations',
      guiItems: null,
      validDate: false,
      lastUpdatedRegistrationData: null,
      loadAgreementsIntervalId: null,
      loadRecentRegIntervalId: null,
      timedOutActionsIntervalId: null
    }
  },
  watch: {
  },
  methods: {
    loadBachRegistrationsFromFinish () {
      this.loadBatchRegistrations(false)
    },
    removeKeyEvents () {
      document.removeEventListener('keydown', this.keyDown)
    },
    addKeyEvents () {
      document.addEventListener('keydown', this.keyDown)
    },
    handleHit (item, evt) {
      this.$emit('hit', item)
      evt.preventDefault()
    },
    keyDown (event) {
      if ((event.key === 'ArrowUp')) {
        event.preventDefault()
        this.handleSelectionKey(event)
      }
      if ((event.key === 'ArrowDown')) {
        event.preventDefault()
        this.handleSelectionKey(event)
      }
      if ((event.key === 'Enter')) {
        event.preventDefault()
        this.handleSelectionKey(event)
      }
    },
    handleSelectionKey (evt) {
      if (this.registrations.length < 1) return
      const active = this.findActiveItemIndex()
      switch (evt.code) {
        case 'ArrowUp':
          this.setActiveItem((active > 0) ? (active - 1) : (this.guiItems.length - 1))
          break
        case 'ArrowDown':
          this.setActiveItem((active + 1) % this.guiItems.length)
          break
        case 'Enter':
          this.$emit('hit', this.findActiveItem())
          this.$router.push({ name: 'batch-registration-create-registration', params: { id: this.focusedRegistration.AgreementId } })
          break
      }
    },
    findActiveItem () {
      const idx = this.findActiveItemIndex()
      return (idx < 0) ? null : this.guiItems[idx]
    },
    findActiveItemIndex () {
      for (let i = 0; i < this.guiItems.length; i++) {
        const item = this.guiItems[i]
        if (item.active) {
          return i
        }
      }
      return -1
    },
    setActiveItem (idx) {
      this.guiItems.forEach((item, i) => {
        if (i === idx) {
          item.active = true
          item.selectedReg = 'selected'
          this.focusedRegistration = item._props.batchRegistration
          item.$el.scrollIntoView(false)
        } else {
          item.active = false
        }
      })
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }
      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)
      await this.loadBatchRegistrations(false)
    },
    async loadBatchRegistrations (skipLoading) {
      if (!skipLoading) {
        this.loading = true
      }
      const res = await BatchRegistrations.loadRegistrations(this.facilityNo)
      if (!res.failed) {
        this.registrations = res.data
      }
      /* const recentres = await BatchRegistrations.loadrecentRegistrations(this.facilityNo)
      if (!recentres.failed) {
        this.recentregistrations = recentres.data
      } */
      if (!skipLoading) {
        this.loading = false
      }
      this.$nextTick(() => {
        if (this.$children.length > 0) {
          this.guiItems = this.$children[0].$children.filter(item => item._props.batchRegistration)
          if (this.guiItems.length > 0) {
            this.guiItems[0].active = true
            this.focusedRegistration = this.guiItems[0]._props.batchRegistration
          }
        }
      })
    },
    async loadBatchRecentRegistrations (skipLoading) {
      if (!skipLoading) {
        this.loading = true
      }
      /* const res = await BatchRegistrations.loadRegistrations(this.facilityNo)
      if (!res.failed) {
        this.registrations = res.data
      } */
      const recentres = await BatchRegistrations.loadrecentRegistrations(this.facilityNo)
      if (!recentres.failed) {
        this.recentregistrations = recentres.data
      }
      /* if (!skipLoading) {
        this.loading = false
      }
      this.$nextTick(() => {
        if (this.$children.length > 0) {
          this.guiItems = this.$children[0].$children.filter(item => item._props.batchRegistration)
          if (this.guiItems.length > 0) {
            this.guiItems[0].active = true
            this.focusedRegistration = this.guiItems[0]._props.batchRegistration
          }
        }
      }) */
    },
    startActionTimeOutTimer () {
    // if the system is idle for 6min we will stop auto updating
      this.timedOutActionsIntervalId = setInterval(async () => {
        // action time out
        clearInterval(this.timedOutActionsIntervalId)
        clearInterval(this.loadRecentRegIntervalId)
        clearInterval(this.loadAgreementsIntervalId)
      }, 1800000)
    },
    startReloadRecentRegistrationTimer () {
      this.loadRecentRegIntervalId = setInterval(async () => {
      // Re-Load recent registrations
        this.loadBatchRecentRegistrations(true)
      }, 60000)
    },
    startReloadBatchAgreementsTimer () {
      this.loadAgreementsIntervalId = setInterval(async () => {
      // Re-Load agreements
        this.lastUpdatedRegistrationData = new Date()
        this.validDate = true
        this.loadBatchRegistrations(true)
      }, 30000)
    },
    loadBatchRegistrationsClick () {
      this.keepLoadAlive()
      this.loadBatchRegistrations()
    },
    keepLoadAlive () {
      clearInterval(this.loadRecentRegIntervalId)
      clearInterval(this.loadAgreementsIntervalId)
      clearInterval(this.timedOutActionsIntervalId)
      this.startActionTimeOutTimer()
      this.startReloadRecentRegistrationTimer()
      this.startReloadBatchAgreementsTimer()
    }
  },
  computed: {
    timeSinceLastUpdate: function () {
      if (!this.validDate) {
        return
      }
      const hours = this.lastUpdatedRegistrationData.getHours()
      const minutes = this.lastUpdatedRegistrationData.getMinutes()
      const sec = this.lastUpdatedRegistrationData.getSeconds()
      return '' + hours + ':' + minutes + ':' + sec
    }
  },
  beforeDestroy () {
    // Unsubscribe to event listener for events from LoadVehicles(), when only ONE vehicle exist. Update all other details for this vehicle
    this.removeKeyEvents()
    clearInterval(this.loadAgreementsIntervalId)
    clearInterval(this.loadRecentRegIntervalId)
    clearInterval(this.timedOutActionsIntervalId)
    this.$root.$off('msgloadBachRegistrations', this.msgloadBachRegistrations)
  },
  async mounted () {
    this.msgloadBachRegistrations = () => { this.loadBachRegistrationsFromFinish() }
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    this.lastUpdatedRegistrationData = new Date()
    this.validDate = true
    this.startReloadBatchAgreementsTimer()
    this.startReloadRecentRegistrationTimer()
    this.startActionTimeOutTimer()

    this.$parent.$on('selectionKeyPressed', this.handleSelectionKey.bind(this))
    this.addKeyEvents()
    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }

    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) this.facilityNo = storedFacilityNo
    else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }
    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }

    await this.loadBatchRegistrations(false)

    this.$root.$on('msgloadBachRegistrations', this.msgloadBachRegistrations)
  }
}
</script>
<style>
</style>
